export default "__VITE_ASSET__Z8UNoTt0__"